export default __webpack_public_path__ + "static/new8-06-2ff9a16ca69902598b42473c59cee2fa.jpg";